<template>
    <div>
        <div class="memberBox">
            <div class="staff">
                <h4>员工列表</h4>
                <p style="border: 1px solid #3b63f6;width: 80px"></p>
            </div>
            <div class="staffList">
                <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
                    <template slot="menuLeft" slot-scope="{size}">
                        <el-button  :size="size" class="View">添加员工</el-button>
                    </template>
                    <template slot-scope="scope" slot="menu">
                        <el-button  class="View">编辑</el-button>
                        <el-button  class="View">离职删除</el-button>
                    </template>
                </avue-crud>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "member",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [
                    {
                        name:'张三',
                        account:'男',
                        department:'市场部',
                        role:'管理员',
                        state:'在职',

                    }, {
                        name:'李四',
                        account:'女',
                        department:'市场部',
                        role:'普通员工',
                        state:'离职',

                    }
                ],
                option:{
                    addBtn:false,
                    stripe:true,
                    align:'center',  // 表格列齐方式
                    menuAlign:'center', // 菜单栏对齐方式
                    columnBtn:false, //列动态显隐按钮
                    refreshBtn:false, // 刷新按钮
                    delBtn:false, // 行内删除按钮
                    editBtn:false, // 行内编辑按钮
                    column:[
                        {
                            label:'姓名',
                            prop:'name',
                            search:true,

                        }, {
                            label:'性别',
                            prop:'account',
                            search:true,
                        }, {
                            label: '部门',
                            prop: 'department',
                            search:true,
                        }, {
                            label: '角色权限',
                            prop: 'role',
                            search:true,
                        }, {
                            label: '状态',
                            prop: 'state'
                        },
                    ]
                },
            };
        },
        methods:{
            changePage(num){
                console.log(num)
            }
        }
    }
</script>

<style scoped>
    .memberBox{
        padding: 30px;
        background-color: #fff;
        margin: 10px;
        border-radius: 5px;
    }
    .staff>h4{
        width: 80px;
        color: #3b63f6;
        text-align: center;
        margin-bottom: 8px;
    }
    .staffList{
        margin-top: 30px;
    }
    .View{
        background-color: #3b63f6;
        color: #fff;
    }
    /deep/.el-card{
        text-align: center;
    }
</style>
